import {AfterViewChecked, Component, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewEncapsulation} from '@angular/core';
import { RouterModule} from "@angular/router";
import {FireworksAdComponent} from "@white-label/components/advertisement-effects/fireworks/fireworks-ad.component";
import {
    NotificationWidgetComponent
} from "@white-label/components/advertisement-effects/incomplete-widgets/notification-widget/notification-widget.component";
import {
    SponsoredByAdComponent
} from "@white-label/components/advertisement-effects/sponsored-by/sponsored-by-ad.component";
import {
    NotificationAdModel,
    SponsoredByAdModel
} from "@white-label/components/advertisement-effects/ads.models";
// import {MainStoreService} from "@cybfed/core/store/main.store.service";
// import {SocketMainService} from "@cybfed/core/services/socket/socket-main-service";
// import {appConstants} from "@cybfed/constants";
// import {AddTypesEnum} from "@white-label/components/advertisement-effects/fireworks.model";
import {DynamicScaleDirective} from "@cybfed/core/utils/dynamic-scale.directive";
import {EventService} from "@cybfed/core/store/event.service";


@Component({
    selector: 'white-label-advertising',
    standalone: true,
    imports: [
        RouterModule,
        FireworksAdComponent,
        NotificationWidgetComponent,
        SponsoredByAdComponent,
        DynamicScaleDirective
    ],
    providers: [EventService],
    styleUrls: ['./advertising.component.scss'],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './advertising.component.html'
})
export class AdvertisingComponent implements OnInit, OnDestroy {
    ads: any = [];
    sponsors: SponsoredByAdModel = new SponsoredByAdModel();
    notificationAdsList: NotificationAdModel[] = [];
    fireworks: any = [];

    constructor(

    ) {

    }

    ngOnInit(): void {
        // const checking = customSetInterval(()=>{
        //     if(SocketMainService.connection.value){
        //         this.setupEvents();
        //         clearInterval(checking)
        //     }
        // }, 2000)

    }

    setupEvents(): void {
        // this.socketService.joinRoom(appConstants.EVENTTYPES.STREAM_ADVERTISEMENT, this._mainStoreService.whiteLabel._id,)
        // this.socketService.listenToEventWithCallback(appConstants.ACTIONTYPES.ADD, appConstants.EVENTTYPES.STREAM_ADVERTISEMENT, (order: any) => {
        //     console.log('socketData_STREAM_ADVERTISEMENT', order);
        //     // switch (order.type) {
        //     //     case AddTypesEnum.fireworks:
        //     //         this.fireworks.push(
        //     //             order.metadata.logo
        //     //         );
        //     //         break;
        //     //     case AddTypesEnum.sponsors:
        //     //         this.addToSponsors(order.metadata);
        //     //         break;
        //     //     case AddTypesEnum.textAd:
        //     //         this.addToNotificationsList({
        //     //             logo: order.metadata.logo,
        //     //             message: order.metadata.message,
        //     //             title: order.metadata.name
        //     //         });
        //     //         break;
        //     //     case AddTypesEnum.notificationAd:
        //     //         this.addToNotificationsList(order.metadata);
        //     //         break;
        //     //     default:
        //     //         break;
        //     // }
        //     // this.ads.push(order);
        // })
    }

    ngOnDestroy() {
        // this.socketService.unJoinRoom(StorageService.statics.whiteLabelId)
    }

    removeFromNotifications(index: any) {
        this.notificationAdsList.splice(index, 1);
    }

    removeFromSponsors(index: any) {
        this.sponsors.logos.splice(index, 1);
    }

    removeFromFireworks(index: any) {
        this.fireworks.splice(index, 1);
    }

    addToSponsors(item: any) {
        this.sponsors.logos.push(item.logo);
    }

    addToNotificationsList(item: any) {
        this.notificationAdsList.push(
            {
                logo: item.logo,
                message: item.message,
                title: item.name,
            }
        );
    }


}
